const BASE_AMOUNT = 100000
export const DEFAULT_PLAN = 5
export const checkInstallmentAmount = (amount: number) => amount >= BASE_AMOUNT

export const amountPerInstallment = (amount: number, plan: number = DEFAULT_PLAN): string =>
  (amount / plan).toLocaleString()
